<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>组合商品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div style="padding: 10px; background-color: #ffffff">
        <el-button type="primary" @click="createClick"> 新建组合商品 </el-button>
      </div>
      <div style="color: #919191">
        当美团或饿了么平台使用组合商品时，在这创建组合品，并将组合品编号设置为
        渠道商品的自定义编号（美团叫店内码）
      </div>
      <x-table
        ref="list"
        listApi="biz.goods.combination.info.list"
        paginationLayout="total, sizes, prev, next, jumper"
        emptyLabel="暂无组合商品信息"
        actionFixed="right"
        :fieldList="fieldList"
        :defaultParams="defaultParams"
        :actionList="actionList"
        :actionWidth="180"
      >
        <template slot="row-info" slot-scope="scope">
          <div>{{ scope.row.title }}</div>
          <div>组合编号：{{ scope.row.guid }}</div>
        </template>
      </x-table>
    </el-card>
  </div>
</template>

<script>
import formPage from "./form.vue";

export default {
  computed: {
    defaultParams() {
      return Object.assign(this.queryModel || Object.assign({}, this.formInline));
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    clearClick() {
      this.formInline = {};
      this.queryModel = null;
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    createClick() {
      this.$drawer.openDrawer(
        {
          title: "新增组合商品信息",
          refresh: this.refresh,
          component: formPage,
          params: {},
        },
        true
      );
    },
  },
  data() {
    return {
      aiLoading: false,
      queryModel: null,
      formInline: {},
      fieldList: [
        {
          label: "组合商品信息",
          minWidth: "360",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "编辑",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer(
              {
                title: "编辑组合商品信息",
                refresh: this.refresh,
                component: formPage,
                params: {
                  guid: row.guid,
                },
              },
              true
            );
          },
        },
        {
          label: "删除",
          linkType: "danger",
          click: (row, tag, refresh) => {
            this.$confirm(`确定删除，此操作不可恢复，请谨慎操作?`, "提示", {
              type: "warning",
            }).then(() => {
              this.requestApi(
                "biz.goods.combination.info.delete",
                {
                  guid: row.guid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.success("保存成功");
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
    };
  },
};
</script>
